jQuery(document).ready(function(){
    jQuery('.wp-block-vif-advanced-video').each(function(){
        let currentVideo = jQuery(this);
        let miniatureContainer = currentVideo.find('>.miniature-container');
        let videoContainer = currentVideo.find('>.video-container');
        let initialFrame = currentVideo.find('iframe').length ? videoContainer.find('iframe').clone() : false;
        miniatureContainer.click(function(){
            videoContainer.addClass('active');
            jQuery('body').append(videoContainer);
            if(videoContainer.find('video').length){
                videoContainer.find('video').get(0).play();
            }                
        })
        videoContainer.click(function(){
            videoContainer.removeClass('active');
            miniatureContainer.after(videoContainer);
            if(videoContainer.find('iframe').length){
                videoContainer.find('iframe').remove();
                setTimeout(function(){
                    videoContainer.append(initialFrame.clone());
                },150)
            }
            if(videoContainer.find('video').length){
                videoContainer.find('video').get(0).pause();
                videoContainer.find('video').get(0).currentTime = 0;
            }
        })
    })
})